var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconChevronBack = function SvgIconChevronBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    viewBox: "0 0 8 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M5.955.288a1.004 1.004 0 0 1 1.411.003l.084.095a.995.995 0 0 1-.08 1.316L2.394 6.676l4.975 4.975c.352.352.384.924.08 1.317l-.083.094a.995.995 0 0 1-1.411.003L.292 7.402a.99.99 0 0 1-.287-.656.99.99 0 0 1 .287-.795z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.955.288a1.004 1.004 0 0 1 1.411.003l.084.095a.995.995 0 0 1-.08 1.316L2.395 6.676l4.975 4.975c.352.352.384.924.08 1.317l-.083.094a.995.995 0 0 1-1.411.003L.293 7.402a1 1 0 0 1-.287-.656.99.99 0 0 1 .287-.795z"
  })));
};
export default SvgIconChevronBack;